import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
declare var gtag;

@Component({
	selector: 'app-google-analytics-gtag',
	template: '',
})
export class GoogleAnalyticsGTagComponent implements OnInit {
	trackingCode = environment.googleAnalyticsTrackingCode;

	constructor(
		@Inject(PLATFORM_ID) private readonly platformId: Object,
		private readonly renderer: Renderer2,
		private readonly el: ElementRef,
		private router: Router
	) {
		// BROWSER
		if (isPlatformBrowser(this.platformId)) {
			const script = this.renderer.createElement('script') as HTMLScriptElement;
			script.src = `//www.googletagmanager.com/gtag/js?id=${this.trackingCode}`;
			script.async = true;
			this.renderer.appendChild(this.el.nativeElement, script);

			const script2 = this.renderer.createElement('script') as HTMLScriptElement;
			const scriptBody = this.renderer.createText(`
				window.dataLayer = window.dataLayer || [];
				function gtag() {
				dataLayer.push(arguments);
				}
				gtag('js', new Date());
			`);
			this.renderer.appendChild(script2, scriptBody);
			this.renderer.appendChild(this.el.nativeElement, script2);
		}
	}

	ngOnInit() {
		const navEndEvent$ = this.router.events.pipe(filter(e => e instanceof NavigationEnd));
		navEndEvent$.subscribe((e: NavigationEnd) => {
			if (isPlatformBrowser(this.platformId)) {
				gtag('config', this.trackingCode,
					{
						'page_path': e.urlAfterRedirects
					}
				);
			}
		});
	}
}
